import {
  Box,
  Grid,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { CustomDetailOrder, CustomOrder } from "../components";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import { useTranslation } from "react-i18next";
import { RootState } from "../../../redux/store";
import { Commande, getCommandes } from "../slices/orderSlice";
import {
  fetchOrderDetails,
  selectOrder,
  clearOrderDetails,
  clearPreOrderDetails,
} from "../slices/detailOrderSlice";
import { CustomLoading, CustomLoadingDetail } from "../../../components/shared";

const ListCommandePageRepresentant = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { data, loading, error } = useAppSelector(
    (state: RootState) => state.orderSlice
  );
  const { businessId, name } = useAppSelector((state) => state.authSlice);


  const {
    data: orderDetails,
    loading: loadingDetails,
    error: errorDetails,
    selectedOrder,
  } = useAppSelector((state: RootState) => state.detailOrderSlice);
  const { direction } = useAppSelector((state) => state.languageSlice);
  const [isLoadingNewDetails, setIsLoadingNewDetails] = useState(false);

  const [filter, setFilter] = useState("");

  const [statusFilter, setStatusFilter] = useState("");

  useEffect(() => {
    dispatch(getCommandes());


    return () => {
      dispatch(clearOrderDetails());

    };
  }, [dispatch, businessId, name]);

  const handleOrderClick = (orderNumber: string) => {
    dispatch(selectOrder(orderNumber));
    setIsLoadingNewDetails(true);
    dispatch(fetchOrderDetails(orderNumber)).finally(() => {
      setIsLoadingNewDetails(false);
    });
  };

  const handleFilterChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFilter(event.target.value);
  };

  const handleStatusFilterChange = (event: SelectChangeEvent<string>) => {
    setStatusFilter(event.target.value as string);
  };

  const filteredData = data?.filter((order) => {
    const filterLowerCase = filter.toLowerCase();
    const statusFilterLowerCase = statusFilter.toLowerCase();
    return (
      (!statusFilter ||
        (order.StatutFinal &&
          order.StatutFinal.toLowerCase().includes(statusFilterLowerCase))) &&
      ((order.StatutFinal &&
        order.StatutFinal.toLowerCase().includes(filterLowerCase)) ||
        new Date(order.DateCommande).toLocaleDateString().includes(filter) ||
        (String(order.NumeroCommande) &&
          String(order.NumeroCommande)
            .toLowerCase()
            .includes(filterLowerCase)) ||
        order.MontantTTC.toString().includes(filter))
    );
  });

  useEffect(() => {
    if (filteredData?.length === 0 && selectedOrder) {
      dispatch(clearOrderDetails());
    }
  }, [filteredData, selectedOrder, dispatch]);

  return (
    <>
      <Typography
        variant="h5"
        sx={{
          marginBottom: "2%",
          direction: direction === "ltr" ? "ltr" : "rtl",
        }}
      >
        {t("commandesClient.title")}
      </Typography>
      <Grid container columnGap={2}>
        <Grid item xs>
          <TextField
            fullWidth
            label={t("commandesClient.filterText")}
            value={filter}
            onChange={handleFilterChange}
            sx={{ marginBottom: "2%" }}
          />
        </Grid>
        <Grid item xs>
          <Select
            fullWidth
            value={statusFilter}
            onChange={handleStatusFilterChange}
            displayEmpty
            sx={{ marginBottom: "2%" }}
          >
            <MenuItem value="">
              <em>{t("commandesClient.filterStatut")}</em>
            </MenuItem>
            <MenuItem value="En cours">En cours</MenuItem>
            <MenuItem value="Créée">Créée</MenuItem>
            <MenuItem value="Validée">Validée</MenuItem>
            <MenuItem value="En livraison">En livraison</MenuItem>
          </Select>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={12} sm={12} md={5} lg={6}>
          <Box sx={{ maxHeight: "500px", overflowY: "auto", padding: "2%" }}>
            {loading && <CustomLoading />}
            {error && <Typography>{error}</Typography>}
            {filteredData && filteredData.length > 0 && !loading ? (
              filteredData.map((order: Commande, index: number) => (
                <CustomOrder
                  key={index}
                  order={order}
                  isSelected={selectedOrder === order.NumeroCommande}
                  onClick={() => handleOrderClick(order.NumeroCommande)}
                />
              ))
            ) : !loading ? (
              <Typography>{t("commandesClient.videCommande")}</Typography>
            ) : null}
          </Box>
        </Grid>

        <Grid item xs={12} sm={12} md={7} lg={6} sx={{ paddingLeft: "3%" }}>
          {loadingDetails || isLoadingNewDetails ? (
            <CustomLoadingDetail />
          ) : errorDetails ? (
            <Typography>{errorDetails}</Typography>
          ) : orderDetails && selectedOrder != null ? (
            <CustomDetailOrder
              orderDetails={orderDetails}
              onFetchOrderDetails={() =>
                dispatch(fetchOrderDetails(selectedOrder))
              }
            />
          ) : (
            <Typography>{t("commandesClient.noItemSelected")}</Typography>
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default ListCommandePageRepresentant;
